export default "__VITE_ASSET__BqaEikDb__"